// 중복된 출퇴근 기록 정리 함수

import { collection, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from './config';

// 특정 사용자의 중복 기록 정리
export const cleanupDuplicateRecords = async (userId) => {
  try {
    const q = query(
      collection(db, 'attendance'),
      where('userId', '==', userId)
    );
    
    const querySnapshot = await getDocs(q);
    const recordsByDate = {};
    
    // 날짜별로 기록 그룹화
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const date = data.date;
      
      if (!recordsByDate[date]) {
        recordsByDate[date] = [];
      }
      
      recordsByDate[date].push({
        id: doc.id,
        ...data,
        timestamp: data.createdAt || new Date(0) // createdAt이 없으면 오래된 것으로 간주
      });
    });
    
    // 각 날짜별로 가장 최신 기록만 남기고 나머지 삭제
    let deletedCount = 0;
    
    for (const date in recordsByDate) {
      const records = recordsByDate[date];
      
      if (records.length > 1) {
        // timestamp 기준으로 정렬 (최신순)
        records.sort((a, b) => {
          const timeA = a.timestamp?.toDate ? a.timestamp.toDate() : new Date(a.timestamp);
          const timeB = b.timestamp?.toDate ? b.timestamp.toDate() : new Date(b.timestamp);
          return timeB - timeA;
        });
        
        // 가장 최신 기록을 제외하고 나머지 삭제
        for (let i = 1; i < records.length; i++) {
          await deleteDoc(doc(db, 'attendance', records[i].id));
          deletedCount++;
          console.log(`중복 기록 삭제: ${date} - ${records[i].id}`);
        }
      }
    }
    
    return { success: true, deletedCount };
  } catch (error) {
    console.error('중복 기록 정리 오류:', error);
    return { success: false, error: error.message };
  }
};

// 전체 사용자의 중복 기록 정리 (관리자용)
export const cleanupAllDuplicateRecords = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'attendance'));
    const recordsByUserAndDate = {};
    
    // 사용자별, 날짜별로 기록 그룹화
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const key = `${data.userId}_${data.date}`;
      
      if (!recordsByUserAndDate[key]) {
        recordsByUserAndDate[key] = [];
      }
      
      recordsByUserAndDate[key].push({
        id: doc.id,
        ...data,
        timestamp: data.createdAt || new Date(0)
      });
    });
    
    // 각 사용자-날짜 조합별로 가장 최신 기록만 남기고 나머지 삭제
    let deletedCount = 0;
    
    for (const key in recordsByUserAndDate) {
      const records = recordsByUserAndDate[key];
      
      if (records.length > 1) {
        // timestamp 기준으로 정렬 (최신순)
        records.sort((a, b) => {
          const timeA = a.timestamp?.toDate ? a.timestamp.toDate() : new Date(a.timestamp);
          const timeB = b.timestamp?.toDate ? b.timestamp.toDate() : new Date(b.timestamp);
          return timeB - timeA;
        });
        
        // 가장 최신 기록을 제외하고 나머지 삭제
        for (let i = 1; i < records.length; i++) {
          await deleteDoc(doc(db, 'attendance', records[i].id));
          deletedCount++;
          console.log(`중복 기록 삭제: ${key} - ${records[i].id}`);
        }
      }
    }
    
    return { success: true, deletedCount };
  } catch (error) {
    console.error('전체 중복 기록 정리 오류:', error);
    return { success: false, error: error.message };
  }
};